import { render } from "./AppShowcase.vue?vue&type=template&id=98d5bc64&scoped=true"
import script from "./AppShowcase.vue?vue&type=script&lang=js"
export * from "./AppShowcase.vue?vue&type=script&lang=js"

import "./AppShowcase.vue?vue&type=style&index=0&id=98d5bc64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d5bc64"]])

export default __exports__